import { browserHistory } from 'react-router';

import { loginUser } from '../../api/ApiManager';
import { setAuthenticated } from '../../store/app';

const initialState = {
  isLoading: false,
  user: {
    UserName: '',
    Password: '',
    contexts: [],
  },
};

export const LOGIN_BEGIN = 'LOGIN_BEGIN';
export const LOGIN_SUCCESS = 'LOGIN_SUCCESS';
export const LOGIN_FAILURE = 'LOGIN_FAILURE';

export const LOGOUT_BEGIN = 'LOGOUT_BEGIN';
export const LOGOUT_SUCCESS = 'LOGOUT_SUCCESS';

export const loginStarted = () => {
  return { type: LOGIN_BEGIN };
};

export const loginSuccess = (user, path) => {
  return { type: LOGIN_SUCCESS, user, path };
};

export const loginFailure = (e) => {
  return { type: LOGIN_FAILURE, error: e };
};

export const login = (user) => {
  return (dispatch, getState) => {
    dispatch(loginStarted());
    loginUser(user)
      .then((response) => {
        const path = getState().location.pathname;
        dispatch(setAuthenticated(true));
        dispatch(loginSuccess(response.data, path));
        //dispatch(setAppRefreshedFlag(true));
        browserHistory.push('/events');
      })
      .catch((e) => {
        dispatch(loginFailure(e.response.data));
      });
  };
};

export const logoutStarted = () => {
  return { type: LOGOUT_BEGIN };
};

export const processLogout = () => {
  return { type: LOGOUT_SUCCESS };
};

export const logout = () => {
  return (dispatch) => {
    const path = localStorage.getItem('axsAppDomain');
    dispatch(logoutStarted());
    dispatch(setAuthenticated(false));
    dispatch(processLogout());
    browserHistory.push(!path || path === '/logout' ? '/login' : path);
  };
};

const ACTION_HANDLERS = {
  [LOGIN_BEGIN]: (state) => {
    return Object.assign({}, state, { isLoading: true });
  },
  [LOGIN_SUCCESS]: (state, action) => {
    const user = { UserName: action.user.UserName };
    localStorage.setItem('axsBearerToken', action.user.BearerToken);
    localStorage.setItem('axsRefreshToken', action.user.RefreshToken);
    localStorage.setItem('axsUserName', action.user.UserName);
    localStorage.setItem('axsContextId', action.user.Meta.Context);
    localStorage.setItem('axsAppDomain', action.path);
    return { ...state, user };
  },
  [LOGIN_FAILURE]: (state, action) => {
    return Object.assign({}, state, { isLoading: false, error: action.error });
  },
  [LOGOUT_BEGIN]: (state) => {
    return Object.assign({}, state, { isLoading: true });
  },
  [LOGOUT_SUCCESS]: () => {
    localStorage.removeItem('axsBearerToken');
    localStorage.removeItem('axsRefreshToken');
    localStorage.removeItem('axsUserName');
    localStorage.removeItem('axsContextId');
    localStorage.removeItem('axsLDKey');
    localStorage.removeItem('axsApiEndpoint');
    return initialState;
  },
};

export default function loginReducer(state = initialState, action) {
  const handler = ACTION_HANDLERS[action.type];

  return handler ? handler(state, action) : state;
}



// WEBPACK FOOTER //
// ./src/common/modules/auth.js